import { alpha, type Theme } from '@mui/material/styles';

declare module '@mui/material/IconButton' {
  interface IconButtonPropsSizeOverrides {
    Xs: true;
  }
}

export default function IconButton(theme: Theme) {
  return {
    MuiIconButton: {
      defaultProps: {
        color: 'default'
      },
      styleOverrides: {
        root: ({ ownerState, theme }: any) => {
          // Set base color and borderColor based on color prop
          let baseColor = theme.palette.action.selected;
          let borderColor = theme.palette.action.selected;
          let iconColor: string | undefined = undefined;

          if (ownerState.color && theme.palette[ownerState.color]) {
            baseColor = theme.palette[ownerState.color].main;
            borderColor = alpha(theme.palette[ownerState.color].main, 0.12);
            iconColor = theme.palette[ownerState.color].main;
          }
          if (ownerState.color === 'inherit') {
            iconColor = 'inherit';
          }

          // Set borderRadius based on size
          let borderRadius = theme.spacing(2);
          if (ownerState.size === 'small') {
            borderRadius = theme.spacing(1.5);
          } else if (ownerState.size === 'Xs') {
            borderRadius = theme.spacing(1.25);
          }

          return {
            borderRadius,
            border: '1px solid',
            borderColor,
            color: iconColor,
            '& .MuiTouchRipple-root .MuiTouchRipple-child': {
              borderRadius
            },
            '&:hover': {
              backgroundColor: alpha(baseColor, 0.08)
            }
          };
        },
        sizeLarge: {
          width: '48px',
          height: '48px',
          fontSize: '32px'
        },
        sizeMedium: {
          width: '40px',
          height: '40px',
          fontSize: '24px'
        },
        sizeSmall: {
          width: '36px',
          height: '36px',
          fontSize: '20px'
        },
        sizeXs: {
          width: '32px',
          height: '32px',
          fontSize: '18px'
        }
      }
    }
  };
}
